import { Spin } from "antd"

const Receive = ({ loading, error, children, progress, condition = true }) => {
    if (loading) {
        if (progress)
            return <Spin />

        return null
    }

    if (error) {
        if (progress)
            return <p>Error</p>

        return null
    }

    if (condition)
        return children

    return null
}

export default Receive